import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DID_CLASS } from 'voxloud-types/dist/models';

@Pipe({ name: 'didClass' })
export class DidClassPipe implements PipeTransform {
  constructor(private translate: TranslateService) { }

  transform(value: DID_CLASS): string {
    const token = `common.did-classes.${value.replace('_', '-').toLowerCase()}`
    return this.translate.instant(token).toUpperCase();
  }
}
